(function () {
  var CONTACT_PATH = '/pages/contact-us';
  var ACTION_PARAM = 'action';
  var ACTION_VALUE = '1';
  var IFRAME_ID = 'quick-chat-iframe';
  var OPEN_BUTTON_ID = 'quick-send-btn';
  var MAX_WAIT = 15000;
  var CHECK_INTERVAL = 250;
  var RELEASE_DELAYS = [0, 100, 300, 800, 1500];
  var postMessageSent = false;

  if (window.__satellaiContactQuickcepAutoload) return;

  function shouldAutoOpenQuickcep() {
    var currentPath = window.location.pathname.replace(/\/+$/, '');

    if (currentPath !== CONTACT_PATH) return false;

    try {
      return new URLSearchParams(window.location.search).get(ACTION_PARAM) === ACTION_VALUE;
    } catch (error) {
      return false;
    }
  }

  if (!shouldAutoOpenQuickcep()) return;

  window.__satellaiContactQuickcepAutoload = true;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  function dispatchEventSafely(eventName) {
    try {
      window.dispatchEvent(new CustomEvent(eventName));
    } catch (error) {
      // 自动唤起是增强能力，事件派发失败时静默降级，避免影响 Contact 页面。
    }
  }

  function releaseDeferredQuickcepScripts() {
    // contact-quickcep-autoload.js 是 defer 脚本，可能早于底部 lazy-release 监听器执行。
    // 这里做几次短延迟释放，确保 QuickCep 的 asyncLoad / lazyload 脚本不会因为事件丢失而不加载。
    RELEASE_DELAYS.forEach(function (delay) {
      window.setTimeout(function () {
        dispatchEventSafely('CustomLoad');
        dispatchEventSafely('satellai:third-party-load');
      }, delay);
    });
  }

  function getIframeDocument(iframe) {
    var iframeWindow = iframe && iframe.contentWindow;

    if (!iframe) return null;

    try {
      return iframe.contentDocument || (iframeWindow && iframeWindow.document) || null;
    } catch (error) {
      // 如果 QuickCep iframe 变成跨域，父页面无法直接访问内部按钮，只能依赖后面的兜底方式。
      return null;
    }
  }

  function getElementWindow(element) {
    return (element && element.ownerDocument && element.ownerDocument.defaultView) || window;
  }

  function isClickableElement(element) {
    var elementWindow;
    var rect;
    var styles;

    if (!element || element.disabled || element.getAttribute('aria-disabled') === 'true') return false;

    elementWindow = getElementWindow(element);
    rect = element.getBoundingClientRect();
    styles = elementWindow.getComputedStyle(element);

    return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function dispatchClick(element) {
    var eventWindow;

    if (!element) return false;

    eventWindow = getElementWindow(element);

    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (eventName) {
      var EventConstructor = eventName.indexOf('pointer') === 0 && eventWindow.PointerEvent
        ? eventWindow.PointerEvent
        : eventWindow.MouseEvent;

      try {
        element.dispatchEvent(
          new EventConstructor(eventName, {
            bubbles: true,
            cancelable: true,
            pointerType: 'mouse',
            view: eventWindow
          })
        );
      } catch (error) {
        // 某些浏览器或 iframe 环境不支持构造对应事件，最后会继续用原生 click 兜底。
      }
    });

    if (typeof element.click === 'function') {
      element.click();
    }

    return true;
  }

  function clickQuickcepOpenButton(iframe) {
    var iframeDocument = getIframeDocument(iframe);
    var openButton;

    if (!iframeDocument) return false;

    openButton = iframeDocument.getElementById(OPEN_BUTTON_ID);

    if (!isClickableElement(openButton)) return false;

    return dispatchClick(openButton);
  }

  function callOpenMethod(targetWindow) {
    var candidates = [
      ['quickChatOpen'],
      ['openQuickChat'],
      ['quickChat', 'open'],
      ['QuickChat', 'open'],
      ['quickCep', 'open'],
      ['QuickCep', 'open'],
      ['QuickCEP', 'open']
    ];

    if (!targetWindow) return false;

    for (var i = 0; i < candidates.length; i += 1) {
      var path = candidates[i];
      var owner = targetWindow;

      try {
        for (var j = 0; j < path.length - 1; j += 1) {
          owner = owner && owner[path[j]];
        }

        if (owner && typeof owner[path[path.length - 1]] === 'function') {
          owner[path[path.length - 1]].call(owner);
          return true;
        }
      } catch (error) {
        // QuickCep 外部 API 未公开且不稳定，失败后继续尝试下一种方式。
      }
    }

    return false;
  }

  function postOpenMessage(iframeWindow) {
    var messages = [
      { type: 'quickcep:open' },
      { type: 'openQuickChat' },
      { type: 'open-chat' },
      { type: 'toggle-chat', payload: { open: true } }
    ];

    if (!iframeWindow || typeof iframeWindow.postMessage !== 'function' || postMessageSent) return false;

    postMessageSent = true;

    messages.forEach(function (message) {
      try {
        iframeWindow.postMessage(message, '*');
      } catch (error) {
        // 跨域场景只允许 postMessage；失败时静默降级，继续等待真实按钮。
      }
    });

    return true;
  }

  function tryFallbackOpen(iframe) {
    var iframeWindow = iframe && iframe.contentWindow;

    callOpenMethod(window);
    callOpenMethod(iframeWindow);
    postOpenMessage(iframeWindow);
  }

  function waitForQuickcepButtonAndOpen() {
    var startedAt = Date.now();
    var timer = window.setInterval(function () {
      var iframe = document.getElementById(IFRAME_ID);

      if (iframe) {
        if (clickQuickcepOpenButton(iframe)) {
          window.clearInterval(timer);
          return;
        }

        tryFallbackOpen(iframe);
      }

      if (Date.now() - startedAt >= MAX_WAIT) {
        window.clearInterval(timer);
      }
    }, CHECK_INTERVAL);
  }

  function initContactQuickcepAutoload() {
    releaseDeferredQuickcepScripts();
    waitForQuickcepButtonAndOpen();
  }

  onReady(initContactQuickcepAutoload);
})();
